/**
 * quick-feed · 顶栏图标的悬停速览消息源（M1 演示）
 * ------------------------------------------------------------
 * 云电脑 / 云空间 / 日程 三类入口的角标与悬停预览使用本地种子；
 * 邮件由 mailRepo 的未读收件箱派生，通知由 notifyRepo 未读项派生。
 * 「忽略」只清掉入口上的提醒（本机持久化 ema.quickfeed.v1），
 * 不改邮件已读状态、不删通知以外的业务数据。
 */

export type FeedKind = 'pc' | 'cloud' | 'mail' | 'calendar' | 'notif'

export interface QuickItem {
  id: string
  title: string
  sub: string
  time: string
  /** 点击条目跳转的路由（缺省只关闭浮层） */
  to?: string
}

export const FEED_TITLE: Record<FeedKind, string> = {
  pc: '云电脑提醒',
  cloud: '云空间动态',
  mail: '未读邮件',
  calendar: '近期日程',
  notif: '通知'
}

/** 云电脑 / 云空间 / 日程 种子（邮件、通知在组件内从仓储派生） */
export const FEED_SEED: Partial<Record<FeedKind, QuickItem[]>> = {
  pc: [
    { id: 'pc-1', title: '云电脑 Work-01 已就绪', sub: '上次会话：昨天 18:16 · 可直接连接', time: '10 分钟前', to: '/cloud-pc' }
  ],
  cloud: [
    { id: 'cloud-1', title: '王磊 共享了「Q3 供应链复盘.pptx」', sub: '云空间 · 共享给我', time: '32 分钟前', to: '/cloud-space' },
    { id: 'cloud-2', title: '华南仓盘点资料已同步完成', sub: '8 个文件 · 24.6 MB', time: '2 小时前', to: '/cloud-space' }
  ],
  calendar: [
    { id: 'cal-1', title: '10:00 供应链周例会', sub: '3 号会议室 · 今天', time: '1 小时后', to: '/calendar' },
    { id: 'cal-2', title: '09:30 华南仓视频巡检', sub: '线上会议 · 明天', time: '明天', to: '/calendar' }
  ]
}

const KEY = 'ema.quickfeed.v1'
export type DismissMap = Record<FeedKind, string[]>

function emptyMap(): DismissMap {
  return { pc: [], cloud: [], mail: [], calendar: [], notif: [] }
}

export function loadDismissed(): DismissMap {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '{}')
    return { ...emptyMap(), ...(raw || {}) }
  } catch { return emptyMap() }
}

export function saveDismissed(map: DismissMap) {
  try { localStorage.setItem(KEY, JSON.stringify(map)) } catch { /* 忽略 */ }
}

/** 过滤已被「忽略」的条目 */
export function applyDismissed(kind: FeedKind, items: QuickItem[], map: DismissMap): QuickItem[] {
  const set = new Set(map[kind] || [])
  return items.filter(i => !set.has(i.id))
}
